import { createGlobalStyle } from "styled-components";
import { colors } from "./colors";
import { textStyles } from "./typography";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    ::selection {
        background: ${colors.secondary.main}; /* or any highlight color */
        color: ${colors.text.secondary};
    }

    img, .no-drag {
        user-drag: none;
        -webkit-user-drag: none;
        user-select: none;
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        z-index: 0;
    }

    body,
    html,
    a {
        font-family: 'Motiva Sans Light', sans-serif;
    }


    body {
        margin:0;
        padding-top: 80px;
        border: 0;
        outline: 0;
        background: ${colors.background.primary};
        overflow-x: hidden;
        width: 100%;
        max-width: 100vw;
        overflow-y: auto;
    }

    body.links-page-body {
        padding-top: 0;
    }

    html {
        overflow-x: hidden;
        width: 100%;
        max-width: 100vw;
        overflow-y: auto;
    }

    #root {
        overflow-x: hidden;
        width: 100%;
        max-width: 100vw;
        overflow-y: visible;
    }

    a:hover {
        color: ${colors.text.secondary};
    }

    section, .ant-row {
        scroll-margin-top: 200px;
    }

    /* Prevenir overflow horizontal */
    * {
        box-sizing: border-box;
        max-width: 100%;
    }

    /* Garantir que imagens não ultrapassem */
    img {
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }

    /* Garantir que containers não ultrapassem */
    .ant-container,
    .ant-row,
    .ant-col {
        max-width: 100%;
        overflow-x: hidden;
    }

    /* Garantir que elementos posicionados não ultrapassem */
    [style*="position: absolute"],
    [style*="position: fixed"] {
        max-width: 100vw;
    }

    input,
    textarea {
        border-radius: 4px;
        border: 0;
        background: ${colors.background.white};
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: ${colors.background.white};
            box-shadow: ${colors.shadow.focus} 0px 0px 0px 2px;
        }
    }

    h1 {
        ${textStyles.heading("h1")}
        color: ${colors.text.primary};
    }

    h2 {
        ${textStyles.heading("h2")}
        color: ${colors.text.primary};
    }

    h3 {
        ${textStyles.heading("h3")}
        color: ${colors.text.primary};
    }

    h4 {
        ${textStyles.heading("h4")}
        color: ${colors.text.primary};
    }

    h5 {
        ${textStyles.heading("h5")}
        color: ${colors.text.primary};
    }

    h6 {
        ${textStyles.heading("h6")}
        color: ${colors.text.primary};
    }

    p {
        ${textStyles.body("large")}
        color: ${colors.text.primary};
    }

    a {
        text-decoration: none;
        outline: none;
        color: ${colors.text.primary};

        :hover {
            color: ${colors.text.primary};
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: center;
        padding-top: 1.5rem;
        background: ${colors.background.primary};
    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }

    .ant-drawer-content {
        background: ${colors.background.primary} !important;
    }
`;
